var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDSabah(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 640",
    preserveAspectRatio: "xMidYMid slice",
    id: "svgN",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -105, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "N3",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M586.9 153.1l-5.3-19.6-.2-9.6 4.5-5.5 1.2-17.5L585 97l.3-2.7 2.5-3-1-2.2-2.7-.3-5.6 1.8-6.8 3.4-3.4 6.2 1.7 8.5 2.7 5.9-3.1 8.9-5.1 4.4-7.5 10.6 3.4 2.8-10.6 10.2-3.1-.7-2.7 3.7-3.9 5-1.1 2 8.7 2.7 3.8 1 2.7 8.2 4.8 4.1 2.8.7-2.4 2.1 3 1.7 3.1 3.1 2.8-1.1 2.7.4.7 1.7 4.8 2 .4.7 1.3-1.7 2-2.7 3.5.3 1.3-1.4v-2l-3.4-2.7-1.4-1.8.7-3.7 6.5-.4.7-3.4 1.7-1.6-1.6-11.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N4",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.8 191.4l3.4 3 10.3-7.1 2.2-1.1-.2-5.3-4.1-1.3v-3.9l6.6-4.6.2-5.4 1.5-3.8-.3-.3-.2-6.9 3.4-5 4.8-6.8 7.7-11.5.9-2.3-2.1-.4-4.6-1.1-2.9-6.5-5.3-7.7-.5-3-3.2-1.4-6.1-1.6-4.4 1.6-1 .1-.4 1.6-3 2.9-4.8 1 .2 5v4.3l-1.8 8 1.4 7.3-1.2 3.4-1.1 4.8-1.2.9.4 1.5 2.4 2.7 3.1 1.8.3 3.7-5.1 4.1-.4 5.5-1 8.9-.3 4.8-2.8 4.4-1.4 6.8 3.9-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N6",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.5 204.7l-.1.3 12-.8 3.7-1.8 2.9 1.4 7.3 2.8v-6.1l.4-2.8-3.5-1 2.4-11 2.8-4.4.3-4.8 1-8.9.4-5.5 5.1-4.1-.3-3.7-3.1-1.8-2.4-2.7-.4-1.5-8.2 5.5-5.4 9.8-5.7 7.5-2.5 8.7-5.3 9.1-10.5 5.1-1.7 1 5.8 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N7",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.9 229.2l-5.8-2.7-1.1-4.5 3.5-3.1 2.7-8.2-2.7-2.7-5.2-1.4-7.3-2.8-2.9-1.4-3.7 1.8-12 .8-1 2.2-2.3.7-5-.7-2.7 1.4h-3.2l-2.8.9-3.7 8.3 6.6.4 1.4 1.4 2.7 7.5 2.4 2.1 2.4 2.7.7 7.6.3 4.1 2.7 5.4-3 3.5 4.8 8.9.6 2.7 4.1 2.7 3.8-1 2.1 2.1h3.4l1-1.4 5.5-7.9 2.7-5.4 2.1-6.9 3.1-7.2 5.4-3.1 2.3-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N8",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.5 196.9l-5.8-1.9-6 3.7-7.3 6.9v5.5l-5.2 2.4.7 3.7 7.8.6 3.7-8.3 2.8-.9h3.2l2.7-1.4 5 .7 2.3-.7 1-2.2.1-.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N9",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.5 227.5l-5.5 7.1-3.6 1.6-2.8 4.1.4 2.7h5.3l3.4 6.4 3.9.7.5-4.1-.2-5.1 9.5-3.8 12.4 1.4-.6-6.6-2.4-2.7-2.4-2.1-2.7-7.5-1.4-1.4-12.3-.8.1 5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N10",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M428 243l-.4-2.7 2.8-4.1 3.6-1.6 5.5-7.1 1.6-4.6-.1-5.5-2.1-.2-.7-3.7-5.4 5.8-6.5 3.4-5.9 7.5-4.8 6.5-2.5 4.2-.2 3.7-2 3.8v2.7l4.7 1 1.1-2.7 4.4-3.1.7 6.5.1.1 5.7-9.9zM403 232.7l-4.8 1.4v3.4h5l1.4-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N12",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.8 267.9l2.3-1.6 4.8-.3 2-2.2-.7-3.5-5.4-.9-1.9-3.6.4-4-3.4-.7v-2.7l2-3.8.2-3.7-1.9 3-5.5 5.5.7 4.8 4.5 1.4-1.1 2.7-3.4 6.1-.3 4.5-2.7 2.8.6.6 3.8-.7h1.7l.9.2 2.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.2 275.1l-.3-3.1-2.4-.4h-1.7l-3.8.7-.6-.6-1.1 1.1 6.4 7.9 1.8-2.6zM401.4 273.8l-1.9 3.1 4.4 5.1 3.7 1.5.2-1.6.9-1.2-6.4-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.5 276.9l-.4.8-.9 5.2 1.4 3.1 2.4.3 5.4-.6.2-2.2-3.7-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N13",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.9 263.1l-.7-1.7h-5.1l-3.1.7-5.1-1.4-.4-3.4.4-1.7-3.1-2.8-.7-6.5-4.4 3.1-1.1 2.7-1.3-.3-.4 4 1.9 3.6 5.4.9.7 3.5-2 2.2-4.8.3-2.3 1.6v1.6l-2.4 2.3 1.5.2.3 3.1-1.7 3-2.7 3.8-.3 3.2 2.3.2 5.2-2.4 4.4-.7 8.2-1.7 3.2-2.4-.4-1 2-2.7 5.1-2.1-.6-6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N14",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.2 275.1l-.3-3.1-2.4-.4h-1.7l-3.8.7-.6-.6-1.1 1.1 6.4 7.9 1.8-2.6zM399.1 270.8l-3-2 .3-4.1-3.2.4-2.5-1.3-2.5 2.7 3.1 2.7 5.3 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M408 273.7l-27.9-7.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N17",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.6 291.9l.2-4.1h1l-.2-4-.4-.9.3-1.5-.2-2.4-.6 1-3.2 5.7 1.9 6.6-1.7 5.6 2 .9 1.9-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M396.7 289.2l-42.8 1.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N15",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.4 273.8l-1.9 3.1 4.4 5.1 3.7 1.5.2-1.6.9-1.2-6.4-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M402.9 276.2h-37.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N16",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.5 276.9l-.4.8-.9 5.2 1.4 3.1 2.4.3 5.4-.6.2-2.2-3.7-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M402.1 282.2h-68.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N18",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.7 302.4l-3.7-7.2-4.1-6.8-.1-.6h-1l-.2 4.1 1 2.7-1.9 4.2 5.3 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400.2 297.2l-22.4 3.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N19",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.6 285.2l-1.1-.1-.1.6-5.4.6-2.4-.3-1-2.2.3 4.6 4.1 6.8.3.7 8.4-4.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N23",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402 359.2l-1.4-1.3-1.4-2.1.4-2 1.3-2.4 1-3.5-.6.4-2.1-3.8-1-5.8-1.4-6.2-8.2-1-9.6 5.2-4.4 2.3-6.6 1.4-1.3 3.2-4 4.4 1.3 5.4 3.2 2.5 3.4 2.1 3.6 4.5 12.1 13.3.6-3.2 1.7-1.4 3.8-.3 1.3-3.8h1.4l2.1-2 2.7-1.1-1-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N24",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.6 358l-3.4-2.1-3.2-2.5-1.3-5.4-2.6 2.9-7.1 2.3-9.6 1.8-12.1-.7-1.9-.7v6.7l3.4 1.3 4.1 3.1 5.9 1.7 3.4 2.4 12 3.8 3.4 2.7 6.1 4.5 6.9 6.5 5.5 7.2.6-5.9v-2.4l3.1.4 2.8-4.1-.7-3.1.4-2.6-12.1-13.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N25",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.6 386.3l-6.9-6.5-6.1-4.5-3.4-2.7-12-3.8-3.4-2.4-5.9-1.7-4.1-3.1-3.3-1.3-11.2.6-9.2 13.6 1.5.5 4.4-1.7 8.9 9.9 3.1-3.8 4.5 2.4 2.7.7 4.8 4.1 6.2 2.8 1.7-1.1 3 1.4 3.1-.3v2l-.3 1 1.3 5.2v3.4l2.1 1.4 1.4-.4 1 2.1 2.4 1.7 1.4-1.4 1-6.5 4.1-.3 2.4-3.1 2.4 2 2.7 1.1 1 .6 1.1-1.7 2-1.7.2-2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N26",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.5 360.3h-.1v-6.7l-6.5-2.5-4.3-3.6 2.3-5V340l-2.8-2.3-2.9 4.3-2.8 5-2.7 4.6-8.2 7.1-7.6 8.6-5.9 6.2-5.5 3.9-4.5 1.8v5.5l-.9 5.9-2.1 6.8.9 1.4 2.1-.4 3.4-4.4-.9 4.1 2.5 2.3 4.1 2.3 2.7 3.6.7.5 1.6-2.4 4.8-3.8 1.4-4.7v-12.4l1.7-1.7 3.7-1 .4-2.4 3.4-4.4 1.6.5 9.2-13.6zM330.7 321.3l-1.4-1.9-3.4-1.3-3.2.2 1.3 2 4.8 3.5 2.1-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N27",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.7 421.9l1.6.4 1.6-.7.7 1.2-.4 1.1 1.1.7 2.3.9 3.6 1.4 2.3-.3.7 2.8-.5 2.7 1.6 1.6 2.3 2.8.3 1.3 5.9 3.2 1.6-.4 1.8.4.5-1.6 1.6-1.1 2.2 1.6 2.1.4 1.4-5.1 1-4.8-.7-3.4v-4.5l2.1-4.4 2.7-8.9 2.1.3h2.3v-4l-2-1.4-1-2.1-1.4.4-2.1-1.4v-3.4l-1.3-5.2.3-1v-2l-3.1.3-3-1.4-1.7 1.1-6.2-2.8-4.8-4.1-2.7-.7-4.5-2.4-3.1 3.8-8.9-9.9-4.4 1.7-3.1-1-3.4 4.4-.4 2.4-3.7 1-1.7 1.7v12.4l-1.4 4.7-4.8 3.8-1.6 2.4 7.3 4.6 11.6 4.1 5.3-2.5 1.8-2.8 1.8 1.9-2.5 2.5 1.4 2-1.1 2.3-1.9-1.4-.9 2.8-1.1 2.5 2.5.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N28",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.4 557l1-5.5-1.7-1.7-1.4-3.8 1.7-3.1-.3-3.4-2.4-5.1v-5.8l1.7-3.1-1-1.4-2.1-.7-1-1.7-1.7-1.7-1.7-5.1 1.7-2.1 1-2.4-1-3.1 1.7-7.2-1.4-6.9 2.1-5.1 2.4-6.2-1.4-6.2-6.5-2.4-1-5.5 3.1-5.1 2.1-13-2.1-5.1-2.1-1-3.4-2.4-2.7-.2-1.4-.7-2.1-.5-2.3-1.6-1.6 1.1-.5 1.6-1.8-.5-1.6.5-5.9-3.2-.2-1.4-2.3-2.7-1.6-1.6.5-2.7-.7-2.7-2.3.2-3.7-1.4-2.3-.9-1.1-.7.5-1.1-.7-1.1-1.6.7-1.6-.5-2.1 1.1-2.5-.2-1.6 3.6-.7 8-1.4 3.9-2.7 1.1-2.3 3.9-2.7 2.7h-3.6l-4.1 3.4-.2 3.6 4.3 3 7.1.9 6.4-2.3 7.1-2.3 2.1 1.6 3 2.7.5 5 .9 3.2 1.4 1.8-.5 6.8.9 2.3 1.6 1.1 1.1 7.1.2 6.2-3.7 2.5-3.6 6.2-.9 4.6-3.9 7.1-3.9 3.9-3.6 6.8.5 3.4 2.7 2.5 1.4 1.4-.2 1.6-.9 1.8 1.8 3.4.7 3.4-1.4 2.5-2.5 1.8 2.3 3.9 2.5 4.6 2.1 3.9-.9 5.2.7 3.9 2.5 1.1.7 2.7h1.6l2.5-1.1 2.3 1.4 2.3 1.4 1.1 1.8.2 5.7-2.3 5.9-2.5 3-.2 4.6v5.2l-1.8 3 .9 2.3 1.6.5.5 3 .5 3 2.7.7 2.3 1.4s0-.9 1.1-3l1.1-2.1-.2-4.1 2.7-4.3 1.8-1.4 2.1 1.6.9-4.6 4.3-.5 2.1-5.2 3-.2 1.4-.2 2.5 4.3 4.1-2.1-.5-5.5 3-.2.9-1.4.7-3.9 3.2-.5-1.4-3.9v-5.2l1.4-2.3.7-5.9h.6l-.8-1.6v-.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N33",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M446.8 362.3l-6.2-3.6-2.5-3.5-3.2-.4-.7-3.7-2.9-3.4-2.5-.4-2.8-3.2-3.2-1.2-1.3-3.6-2.4-3.8v.1l-5.2 2.4-4.8 1.4-1.7 3.8-3 3-2.5 1.7-1 3.5-1.3 2.4-.4 2 1.4 2.1 1.4 1.3-3.1 2.8 1 2-.2.1 2.6 2.8 2.3 2.3 1.8 4.8 5.5 4.1 2 3.2.7 8.4 3.9 1.6-.7 1.2.6-.4h1l-1.4 6.1 2.1 6.5 7.2-3.7 9.9-6.5 7.5-3.4 7.2-3.5 5.1-7.1-1.7-5.9-.5-9.5-3.7-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N34",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.6 389.7l-.7-8.4-2-3.2-5.5-4.1-1.8-4.8-2.3-2.3-2.6-2.8-2.5 1-2.1 2h-1.4l-1.3 3.8-3.5.3-.3 4.8 2.7 5.1 1.8 3.5 1.3 4.4.7 6.9.4 5.4 2.3 1.1.7 6.1-.6 2.9 8.8-7 2.4-4.8 4.5-4.4 4.2-2.7.7-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N35",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.6 429.6l4.3.7h3.6l2.6 1.6 1.1 4.8-1.4 1.8.9 2.8 3.5 2.2 4.6-.9.3-2.3 1-4.8v-3l2-6.9 1.7-5.8-.3-6.5 1-4.8-.7-6.1-2.3-1.1-.4-5.4-.7-6.9-1.3-4.4-1.8-3.5-2.7-5.1.3-4.8h-.3l-1.7 1.4-1 5.8.7 3.1-2.8 4.1-3.1-.4v2.4l-.6 5.9-.9-1.2-.2 2.5-2 1.7-1.1 1.7-1-.6-2.7-1.1-2.4-2-2.4 3.1-4.1.3-1 6.5-1.4 1.4-.4-.3v4h-2.3l-2.1-.3-2.7 8.9-2.1 4.4v1.2l18.1 3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N36",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.2 486.5l-.7-1.3-2.7-2.8h-2.7v-1.7l-1.1-5.5-2.7-3.4-2.4-2-2.4-5.5-2-.7-2.4 1.7-2.1 1.4V464l-1.4-1.4v-3.1l2.8-3.1.3-4.4v-8.2l.1-1.2-4.6.9-3.5-2.2-.9-2.8 1.4-1.8-1.1-4.8-2.6-1.6h-3.6l-4.3-.7-4.2-2.5-18.1-3.4v3.3l.7 3.4-1 4.8-1.4 5.1 1.4.7 2.7.4 3.4 2.4 2.1 1 2 5.1-2 13-3.1 5.2 1 5.4 6.5 2.4 1.4 6.2-2.4 6.1-2.1 5.2 1.4 6.8-1.7 7.2 1 3.1-1 2.4-1.7 2 1.7 5.2 1.7 1.7 1 1.7 2.1.7 1 1.3-1.7 3.1v5.8l2.4 5.2.4 3.4-1.8 3.1 1.4 3.7 1.7 1.8-1 5.4v1.1l.8 1.5 4-.2 1 1V557l2.1-2.7 1-2.7 4.8-2.8 2.7-11.3 3.1 2.1 3.1-2.1 2-2.7 1.7-7.5 1.4-2.8 2.4-2.7 1.4-1 2 2 3.5-3.1 2-1.3 2.1-.7v-4.8l-1.4-2.1 1.4-2 3.4-2.8 1-6.5 1-3.4.4-4.8V490z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N37",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.6 477.7l1.6-1.3 3.4 2.5 3.9.9 1.6-.9 1.4-1.8 2.5-2.5.7-4.8-.7-4.8 3.4-6.2 2-4.6 1.4-2.2-1.8-1.4 4.3-2.5 5.5-1.4.7 1.4 2.3.9 4.8-2 4.3-2.1 3-2.3.2-2.9.2-1.6 1.6-1.9 4.6-2.9 3.2 1.6 3.4-.3 3.4-.7 1.4-2.5 3.8-2.6-1.2-.8-5.5-12.6.7-5.5 5.8-7.2 3.8.3 3.8-3 3.7-2.4 4.5.6 2.7-1.7-1-3.4-2.4-2.7-1.7-5.2 3.4-1.3 1-6.9.4-3.7 4.8-1.4 4.4 1 5.5-1v-3.8l-3.1-2-1.4-3.8 2.1-2.7 3.8-5.2-6.9-3-2-.7-.7-3.1-5.5 2.1-4.8-.7-3.1.7-.7-2.8-4.4 3.4-9.6 2.4-10.9 3.8-6.5 6.5.6 11.6 1.7 5.9-5.1 7.1-7.2 3.5-7.5 3.4-9.9 6.5-7.2 3.7-2.1-6.5 1.4-6.1h-1l-4.8 3.1-4.5 4.4-2.4 4.8-8.8 7-.4 1.9.3 6.5-1.7 5.8-2 6.9v3l-1 4.8-.4 3.5v8.2l-.3 4.4-2.8 3.1v3.1l1.4 1.4v2.7l2.1-1.4 2.4-1.7 2 .7 2.4 5.5 2.4 2 2.7 3.4.2 1.1 2.3.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N38",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M574.8 536.5l-2.7.3-5.5-3.1-2-4.1-3.8-.7h-9.2l-2.4-1.7-5.1-4.1-2.7-4.8-6.8.3 3.1-3.8 2.1-3.1 2.4 1 1-3.1-1.7-3.8h3.8l-2.4-5.1-2.4-1-2.1-.7-1.7-1.7-1-3.4-4.1-3.1-.3-3.1-2.7-4.1-4.1-1.4-.3 4.8-4.8-1-2.7-1.7h-4.1l-4.1 1-1.7 2.4-4.5 1.4.3 3.4-2.1 1-.7 5.1-6.5-4.1-3.1-1.7-.3-8.2-2.7-2.4-4.4-14 .7-7.9-.7-5.1 3.4-4.8-.7-8.6-2.4-3.8-2.7-6.8-4.3-2.7-3.8 2.7-1.4 2.5-3.4.7-3.4.2-3.2-1.6-4.6 3-1.6 1.8-.2 1.6-.2 3-3 2.3-4.3 2.1-4.8 2-2.3-.9-.7-1.4-5.5 1.4-4.3 2.5 1.8 1.4-1.4 2.3-2.1 4.6-3.7 6.3.7 4.8-.7 4.8-2.5 2.5-1.4 1.8-1.6.9-3.9-.9-3.4-2.5-1.6 1.4-2.1-1.1-2.3-.3.8 4.4v1.7h2.7l2.7 2.7.7 1.4 2.1 3.4v1.4l-.3 4.8-1 3.4-1 6.5-3.4 2.7-1.4 2.1 1.4 2.1v4.8l-2 .7-2.1 1.4-3.4 3.1-2.1-2-1.4 1-2.4 2.7-1.4 2.7-1.7 7.5-2.1 2.7-3.1 2.1-3.1-2.1-2.7 11.3-4.8 2.7-1 2.7-2.1 2.7v3.4l1.5 1.5 2.1 4.6 5 .7 2.5-1.1 4.1 1.4 3 1.8 3.2.9 1.4 3.2 4.6 4.1 4.1.7 1.8-1.6 2.3-2.3.5-3 1.6-1.6 3.4 1.1 3.6-3.4.7-6.2 1.4-2.1 4.6 3.7 5.9-1.6 5.2 2.7s0 2.3 5-.2l5-2.5 4.8-1.4 4.3 2.1 1.6 3 5.5-.2 1.4 4.6 3.2 2.1.2 6.3c.1-.2.6-.8 4.8-2.2 1.9-.6 2.8-.8 3.2-.8l1.2-4.7 5 1.8 4.1-1.1-1.8-3.6 1.8-5.9 4.6-1.4v-3l3.4 4.8s.2 1.1 2.1.7l1.8-.5 1.4 3.4.7 3.9 5-.7 3.7-1.6 1.6 1.4 4.1 1.1 4.6-2.1 2.3-3.2-.2-4.1 3.4-.2 4.3 5.2.5 2.3s0 2.5 2.1.9l2.1-1.6 1.6.9 3.7 3.2s.5.2 5-1.6l4.6-1.8 3.9-4.1 5 1.1 1.3 1.1 1.9-1.4 1.4-1.7 2.1-3.8 1.7 2.4 3.4-.7 2.7-1 1.4-4.4-.3-2.4-.7-2.4 1.7-2.4 3.1-4.8.3-2.7-1.4-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N39",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M593 287.7l16-15.3s1.8-2.5 3.2-2.7c1.4-.2 3.9.7 4.6.9.7.2 3.2 2.1 3.2 2.1l11.4 11.9h10.3v-33.1h6.2v-20.8s5.5-.7 7.8-1.8 14.4-11.6 15.3-13.2c.9-1.6 2.3-4.8 2.3-4.8h17.6l-1.4-8.7 3.2-3.6 1.8-8.2-6.4-3.6-10.5-8.4-5-2.3-5.5.7-9.1-9.4-4.3-11.2-5.7 11.6-3.6 5.7-5.5-4.1-8.9-5-.7-4.3-11.2-1.1-3-.5-.3-.7-3.2 5.5-1.4 1.4-4.5-.7-2.4 2.7-3.1 2.1-4.1-1.4-6.2.3-1.7 1.7-.7 3.4-6.5.3-.7 3.8 1.4 1.7 3.4 2.7v2.1l-1.4 1.4-3.4-.3-2 2.7-1.3 1.7 2.3 4.1-1 2.4 3.4 4.8-2.1 5.1 2.1 3.4-2.4 1.4-6.5-.3-3.8-2.4h-4.8l-3.4 2.1-1-.7-4.6 3.6.1 1.9 38.7 18.8v25l-.5.1-.5 29.5zM647.1 131.7l-3.2 2.7-8.2-.7-3.7 2.8.9 3.2 6.4 3.4-.9 3.2-4.1 1.3-6.4-1.3-4.8 1.3-3.4 4.1 7.3 3.5 10.7 1.3 11.4-3.8 3.5-4.1v-4.2l-3.2-3.8-2.1-4.6 4.6-1.1-.7-2.3-3.7-2.3zM656.4 136.5l-2.2 3.2-.5 2.7 3.4-2.3zM658.5 139.4l-2.7 2.8 2 1.6 1.6-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M650.5 135.6l-1.1 2.7h3.6l.5-2.1-2.3-.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N40",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M678.6 230.5l3.2-5 4.8 1.1 3.6-1.6 1.4-8.9-.9-5.2h-17.6s-1.4 3.2-2.3 4.8c-.9 1.6-13 12.1-15.3 13.2-2.3 1.1-7.8 1.8-7.8 1.8v20.8h-6.2v33.1h-10.3l-11.4-11.9s-2.5-1.8-3.2-2.1c-.7-.2-3.2-1.1-4.6-.9-1.4.2-3.2 2.7-3.2 2.7l-16 15.3.5-29.7-24.8 3.4-28.1 19.2-1 3.4 1.7 2.4-1.4 2.7-1.4 3.8 3.8 3.1 1.4-.3 4.1.7 2.1 2.1 2.7 1.7 4.4 2.1 4.5 3.1 2.7 8.6 4.8 4.5v1.7l-2.1.7-2.7 3.8h-4.4l-5.1 2.1-4.8.7-1.7 7.9-.7 1.6 5.5.5 4.1 3.4 3.8 2.7 2.4.3 3.1-1 1.7 2.1 3.4 2.7 4.1-1 2.7-1.7 3.4 1.7-1 4.8 5.5 3.1 1.4-.7 2.7-1 1-1 3.1.7 2.7 1 2.1 1.4h4.4l11-3.4 3.8-4.4s1-3.4 2.4-5.5 5.8-3.8 5.8-3.8l30.5-10.6 14.4 1.7 7.2-5.1 8.6-4.5 3.8.3-15.9-27.2 3-5.8-2.9.3-10-1.1-10 3.2 8.2-4.8 7.8-1.6 5.9-3 6.4-5 .5-4.8-1.4-1.6-3.4-2.1-1.1-2.3-2.5 2.5-1.1-3.7 4.8-4.8-.5-6.4-2.3-2.3-4.3 2.1 1.4-3.1 2.1-1.2-4.6-5.3-1.4-8.2 7.5-6.2 1.5 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M688.6 263.5l-2.3 2.8-.7 4.8-1.1 4.8-4.8 3.8 4.3.5 2.8-4.1 2.5-5v-5.3zM678.3 280.6l-2.7 1.9 3.9.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N41",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M732.6 283.2v-2.1l1.4-1.6 3.2-.2 1.8-2.3 3 2.3 3.6 1.3 5.3 1.2 1.6-.4-1.6-.9 1.1-4.7-2-5.5-3.4-5.8V261l-10-2.3-8.3 9.6-7.8 6.4-.5 2.3-9.8 3.8-13.4-1.8.7 3.5 3.4 3.8h-3.2l-5.9 1-7.5-1.2-6.3.6-3 5.8 15.8 26.7-.8-.1 1.8 1.5.3 2 7.2-2 13-12 1.4-5.5 2.7-.3h2.1l4.8-2.4 1-7.9h3.8l7.8 2.4 6.5-3.1 5-1.2-15.9-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N42",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M754 287.8s-.1-1.8 0 0c0 1.8-1.4 2.2-1.4 2.2l-3.4.2-.7.2-1 .1-15.9-3.1 1.1-4.3V281l1.4-1.6 3.2-.2 1.8-2.3 3.2 2.4 3.4 1.3 5 1.2 1.9-.4 1.4 6.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N43",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M734.8 302.3l8.6 9.6-6.3 4.1-11.2-7 5.4 7.9-2 3.5 2.9 4.4 9.4-1.5 3.1-2 2.9-2.3 5.2-.6.6 2.6 4-.6 2.3 1.5 2.9 3.8.7-.2V331.2l-6.2-.7-1 3.4 1 4.4-6.5.7-8.6-1-10.6 1-2.7-1.4 1.7-3.8-3.8-1.7-4.4-1.7-7.9 8.2-6.5-7.5 2.1-6.5-5.8 2.7-4.8-2.4-5.1 1-1.3-3.6 6.4-1.8 13-12 1.4-5.5 2.7-.3h2.1l4.8-2.4 1-7.9h3.8l7.9 2.4 6.8-3.1 5.7-1.3h.8l-.1 4.6s-1.4.7-1.8 1.5c-.4.8 0 0 0 0v2.5s-1.9 3-2 3.8c-.1.8 0 0 0 0l-10.6-.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N44",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M745.2 302.9h6l2.5-.6-1.3-1.1-2.3-3v-2s-1-.4-1-1.2c-1.6 1-1.8 1.5-1.8 1.5v2.5c-1.3 1.4-2.1 3.9-2.1 3.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N45",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M760.5 287.3l-6.4.6s-.3 1.9-1.5 2.2l-3.4.2-.1 4.9c0 .8 1 1.2 1 1.2v2l2.3 3 1.3 1.1 3.2-.8-.2-6.2s.8-1.1 3.1-1l.7-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M756.8 290.6l6.5-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N46",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M757 301.5l5.7-1.4 2.8-2.9-5.5-2.9c-2.3-.1-3.1 1-3.1 1l.1 6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M761.1 297.9l5.6-7.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N47",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M718.5 397.9l-.7-3.4.7-3.4-.3-4.5 1-2.7 3.1-9.9 4.1-7.9 1.4-13.3-3.4-6.8 5.1-7.9-.6-.3 1.7-3.8-3.8-1.7-4.4-1.7-7.9 8.2-6.5-7.5 2.1-6.5-5.8 2.7-4.8-2.4-5.1 1-1.3-3.6-.8.2-.3-2.1-1.8-1.4-3-.3-8.6 4.5-7.2 5.1-14.4-1.7-30.5 10.6s-4.5 1.7-5.8 3.8c-1.4 2.1-2.4 5.5-2.4 5.5l-3.8 4.4-11 3.4h-4.4l-2.1-1.4-2.7-1-3.1-.7-1 1-2.7 1-1.4.7-5.5-3.1 1-4.8-3.4-1.7-2.7 1.7-4.1 1-3.4-2.7-1.7-2.1-3.1 1-2.4-.3-3.8-2.7-4.1-3.4-5.5-.5-1 2.2-3.4 5.8-1.4 7.2-4.4 2.1-1 4.1.3 2.1-2.7.3-6.8-.3-6.5-2.7-7.2-2.7-3.6.2-3.6 4.9-2.1 2.7 1.4 3.8 3.1 2v3.8l-5.5 1-4.5-1-4.8 1.4-.3 3.8-1 6.8-3.4 1.4 1.7 5.1 2.4 2.7 1 3.4-2.7 1.7-4.5-.7-3.8 2.4-3.8 3.1-3.8-.3-5.8 7.2-.7 5.5 5.5 12.7 5.5 3.4 2.7 6.8 2.4 3.8.7 8.6-3.4 4.8.7 5.1-.7 7.9 4.4 14 2.7 2.4.3 8.2 3.1 1.7 6.5 4.1.7-5.1 2.1-1-.3-3.4 4.5-1.4 1.7-2.4 4.1-1h4.1l2.7 1.7 4.8 1 .3-4.8 4.1 1.4 2.7 4.1.3 3.1 4.1 3.1 1 3.4 1.7 1.7 2.1.7 2.4 1 2.4 5.1h-3.8l1.7 3.8-1 3.1-2.4-1-2.1 3.1-3.1 3.8 6.8-.3 2.7 4.8 5.1 4.1 2.4 1.7h9.2l3.8.7 2 4.1 5.5 3.1 2.7-.3.4 1.2 4.1-1.5 1.4-3.8 4.1-.3 6.2-2.3-7.2-7-1.7-2.4h-2.4l-1.7-4.1 1.4-7.9 2.1-5.8 7.5-1.4h5.5l5.8 4.4 11.3-4.4 3.1-3.1-.7-3.8 1.7-2.7 3.1-.3 1-1.7 6.2 3.1 1.4 3.8 2.1-2.1 1.4 3.4 1.4 4.1 5.5 3.1 4.4 1.4 3.8-4.1 6.5-6.2-2.1-3.1-2.4-5.5.7-6.5 1.7-2.4-.7-1.4 1.4-3.1h1l2.7-1.4 2.4-2.4-1.7-5.1.7-1.4-2.7-4.8 2.7-2.4 1 .7 2.7-1-.3-1.7 3.4-.3 3.8-.7 2.4-1.7 2.4-1h2.7l1.4-2.1-2.1-2 3.4-2.1 6.8-2.1 2.1-4.1 1-5.8-1.4-1V429l1.4-2.4 3.4-.7-1.4-3.4 1.7-2.1.7-2.7 4.8-3.4 3.1-1 .7-1.7 2.4-2.1.3-3.4 3.1.7 9 4-.1-7.4 4.3-5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N48",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M904.9 367.1l-1.7-.2-18.7-12.6-1 11.5-2.5-5.1v-7.2l-14.6-7.6-11.8-14.8-5.4-.2-4.7 4.4-1.1 9-3.8 6.4-2.5-3.9 4.1-12.9 5.2-3.9-17.5-15.6-27.5-15.9v5.8l-.3 2.5-5.7-7-7.6-3.3-4.9-.3-4.9 4.7-4.5 1.7-6.3.9-1.5 1.8 2.9 4.3-1.7 5.6-2.3 2.9 1.7 6.7-3 .7V331.2l-6.1-.7-1.1 3.4 1.1 4.5-6.5.6-8.6-1-10.6 1-2.1-1-5.1 7.9 3.4 6.8-1.3 13.4-4.1 7.9-3.1 9.9-1 2.7.3 4.5-.7 3.4.7 3.4-4.1 5.1v7.4l.3.2 3.1-2.4h5.1l5.2 2 6.8 4.8 46.2-7.9 4.5.4 9.9-5.8 1-1.4 5.5-6.5 92.7 1.7 6.5-8.2v-6.2l4.8-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M767.7 300.9l5.5.3 4.3-2.1 2.5-2.6-6.5-1.7-5.2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N50",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M808.8 441.7l-2.4.3-5.8-.3-5.8-1.4-2.4-6.5-.7-3.7-5.1-1.7-6.2.3-2.7-1.7-2.7-4.1-3.5-2.4-8.9-3.1-7.2-5.9-20.5 3.5-6.8-4.8-5.2-2h-5.1l-3.1 2.4-9.2-4.1-3.1-.7-.3 3.4-2.4 2.1-.7 1.7-3.1 1-4.8 3.4-.7 2.7-1.7 2.1 1.4 3.4-3.4.7-1.4 2.4v3.1l1.4 1-1.1 5.8-2 4.1-6.9 2.1-3.4 2 2.1 2.1-1.4 2h-2.7l-2.4 1.1-2.4 1.7-3.8.7-3.4.3.3 1.7-2.7 1-1-.6-2.8 2.4 2.8 4.8-.7 1.3 1.7 5.2-2.4 2.4-2.7 1.3h-1.1l-1.3 3.1.7 1.4-1.8 2.4-.6 6.3 6 1.1 5.5-3.2 1.3 2.7 1.9.5 3.2 3.6 1.3 5h3.7l6.4-4.5 3.6 3.6 4.6.9 4.1-2.7 3.2-4.6 2.7-.9 1.3 2.9 4.4-.6 3.7 3 4.8 2.9 2.7-1.1 5.5-1.4 3.4-2.2 5.9-1.6 1.6-.3 2.5 2.1 2.1-2.3.4-2.7 3.9-3.7-2-2V480l2.5-2.7 3.9-.5.9-4.7 3.4-3 1.4 2.3 3.8-.7 4.4.2 2.3.9h2l2.3 1.2 1.6-.3v-3.4l3.7-1h1.4l1.6-4.3 4.3-2.1v-2.2l1.9-2.3 4.9-2.8 7.2-.6 7.3 1.6 4.5-1 9.2-3.3-.2-1.2-3.5.6-2.8-2.3-2.1-.8-2 1.3-2.5-.3 1.7-3.8 4.9-1.5 5.7 1.3 1.9-1.3-.8-1.6zM815.4 483.8l-3.3-.4s-.8-.8-1.4-.8c-.6 0-2.5.4-2.5.4l-1.2 1.4 1.4 1.8 2.5-1.4 4.5-1zM810.5 487.5s-2.2 1-1 1.6l1.2.6-.2-1.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N51",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M760 471.8h-2l-2.3-.9-4.3-.2-3.9.7-1.4-2.3-3.4 3-.9 4.8-3.9.5-2.5 2.7v1.8l2.1 2.1-3.9 3.6-.5 2.7-2.1 2.3-2.5-2.1-1.6.2-5.9 1.6-3.4 2.3-5.5 1.4-2.7 1.1-4.8-3-3.6-3-4.4.6.6 1.2 3.7 3.7-.5 1.8 2.3 2.7 1.4 5 3.6 2.3 3.7 2.3v2.3l1.8 1.8 1.8 5.9 6.8-5 6.8-4.6 12.3-.5 5.9-.9 8.7 5.9 6.8 2.7 8.2.9 8.7 2.3 5.5 7.2 1.4-1.7 2.7-3.2 5-.5 1.4-3.2 3.2-2.7.6-3.6-2.1.2-.8-4.1-2.7-2.9h-2.5l-4.3-3.9-2.5-3.7-2-.4.2-1.8-2.2-1.6-1.8-3.3-2.2-2.4 1.4-3.1-1-3.7-3.1-3.5-2.2-3.5-1.8-.4s-.8 1.4-3.1 0l-2.2-1.4v-1.9l-1.6.2-2.5-.8zM799.5 482.4L797 481l-.6 1.2v.6l2.1.4zM792.7 479.7l-1.8-.8-.2 1 2.2 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N52",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M827.7 530l-.5 2.6 2.6.9 1.4-.8.8-5.5-3.6-2.5-.4 1.5zM819.1 506.1l-1.8.8-5.9.3-4.7.4-4.3-.7-3.7 1.9 3 2.2 7-.6 2.9 1.5 4.3 1.6 4.1 1.2 2.6 1.5 3.9 1 1.8-2.1 2.9 2.5 4.9 1.4.8-2.8 1.9.6 1 2.4 1.4-.4.6-2.8 1.9-1.1 2.2-1.8-3.4-2.9-5.2-2.6-2.4 2.4-4.3.2-2.5-3-1.2-2.1-2.7-4.1h-1.8l-4.9 3.1zM818.9 500.8l-2.4 1.6-3.3-.6-2.5-1.4 3.1-1.6 2.9.8zM826.5 496.7l-2-.8-4.1 1v1.7l2.6.6 3.1-1zM844.3 524.5l-2.9 1.1-3.2 2-3.3 1.7v1.6l3.9-1 1.8-.9 1-1.2h3.5zM850.2 524.8h-1.4l-1.2 1.2 1.6.2 2.1-.4zM869.5 516.2l2-2.5 2.9-.8 5.1 1 2 1.4 2.3 2.5-2.9 3.1-.2-2.1-.4-2-2.3-.8-2.4-1.3h-1.8v1.9l-3.1 1.4zM853.9 537l.2 2.5 2.1 2.6 2.4 3.5 1 2.7-1 1.8 1.9 1.5 3.8-3.7 3.7-1.1 4.5.3 2.9-2.1-2.7-1.6-4.1-.9-2.2-1-2.3-1.8-1.4-2.1h-4.1l-3.5-.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N53",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M855.6 545.8l-2.3-1.8-1-3.1-3-1.6-11 6.4-3.8 2.8-7.5-.4-6.5.4-4.8 2-13.4.4-5.4-4.1-10.7-2.7-.6 4.6 4.1 5.5 5.4 1.8 6 5.5 5.1 3.5 2.9-.4 4.7 1.9 4.9-.4 3.9-1.5 5.5-1.8 4.9 1.4 6.6-.4.2-2.4v-2.3l4.1.2 2.4-4.1 1.3-1-1.7-1.8-2.8-1.9 4.5-1.6 1.6 4.7 3.3.2 2.2-4.5 2.9-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N54",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.3 550.9l13.4-.4 4.8-2 6.5-.4 7.5.4 3.8-2.8 11-6.4-.5-.2-1.6-1.5-2.9.9 1.2-3.1 1.9-1-3.1-1.5-6.6-.2-4.2 3.7-2.1 1.6-7.4-3.6-3.2-.9.8-2.2 4.3.8 1.3.5.5-2.6.3-3.8.4-1.5-1.1-.8-2.6.4-3.9-4.5-3.3-1-2.5 3.3-2-.6-3.5-2.1-2.6-4.7-.4-1H803l-4.1.4-.6 3.6-3.2 2.7-1.3 3.2-5 .5-2.8 3.2-1.3 1.6.4.6.5 6.9.9 5.5-.3 2.2 10.7 2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N55",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M785.6 536.4l-.5-6.8-5.9-7.8-8.7-2.3-8.2-.9-6.8-2.7-8.7-5.9-5.9.9-8.6.3-2.8 34.8.5 4.1.9 3.6-.5 6.8 1.8 10-.5 3.2 3.9 1.1s1.8 2.5 1.6 3.2c-.2.5-1.8 1.9-2.7 2.6-.3.2-.5.4-.5.4l2.1 1.1 4.3.8 2.4-3.4 3.1-3.1 3.4-.3 2.7-1 4.1-5.1 5.8-7.2 3.4-8.2 6.8-6.2 14-4.9.2-1.7-.7-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M734.5 580.7c.9-.7 2.5-2.1 2.7-2.6.2-.7-1.6-3.2-1.6-3.2l-3.9-1.1-3.2 2.3-1.8 3.6-3.9 2.4 5.3 1.5 3.9-2.1.8.6.7-1.3 1-.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N56",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M804 564.9l1.4.2.7-.1-5.1-3.5-5.9-5.5-5.5-1.8-4.1-5.5.7-5.1-14 4.9-6.8 6.2-3.4 8.2-5.8 7.2-4.1 5.1-2.7 1-3.4.3-3.1 3.1-2.4 3.4-4.3-.8-2.1-1.1s.2-.2.5-.4l-1.1.1-.7 1.3 3.5 2.4 3.4 2.3h4.8l7.8-3 6.6-4.6 4.3-1.6 6.6-3 11.6.2 4-3.3 5.9-2.7 12.6.3 2.3-1.1-2.2-3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N57",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M734.5 580.7c.9-.7 2.5-2.1 2.7-2.6.2-.7-1.6-3.2-1.6-3.2l-3.9-1.1-3.2 2.3-1.8 3.6-3.9 2.4 5.3 1.5 3.9-2.1.8.6.7-1.3 1-.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N58",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M730.8 553.7l-.9-3.6-.5-4.1 2.8-34.8-3.7.1-6.8 4.6-6.9 5-1.8-6-1.8-1.8v-2.3l-3.7-2.3-3.6-2.2-1.4-5-2.3-2.8.5-1.8-3.7-3.7-1.8-4.1-2.7.9-3.2 4.6-1.2.8 3.2 7.4 1.9 5.5-1.4 4.8v3.9l3.2 2.2.2 2.3-2.7 2.5-5 4.4-3 5 .7 4.6 4.1 2.7 7.1.2 10.5-.4 3.6 1.3.7 2.1-1.4 1.3-4.1 2.1-.4 2.3 1.6 7.3 4.3 2 2.3-1.8 2.5-1.4 1.8 1.9 1.6 3.2v4.5l-.5.9-2.5 1.4-1.6.2.3 1.6 2.3 7.7.4.3 3 4.4 2 .5 3.9-2.4 1.8-3.6 3.2-2.3.5-3.2-1.8-10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N59",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M714.8 567.6l1.6-.2 2.5-1.4.5-.9v-4.5l-1.6-3.2-1.8-1.9-2.5 1.4-2.3 1.8-4.3-2-1.6-7.3.4-2.3 4.1-2.1 1.4-1.3-.7-2.1-3.6-1.3-10.5.4-7.1-.2-4.1-2.7-.7-4.6 3-5 5-4.4 2.7-2.5-.2-2.3-3.2-2.2v-3.9l1.4-4.8-1.9-5.5-3.2-7.4-2.9 1.9-4.6-.9-3.6-3.6-6.4 4.5h-3.7l-1.3-5-3.2-3.6-1.9-.5-1.3-2.7-5.5 3.2-6-1.1v.2l2.4 5.4 2 3.1-6.5 6.2-3.8 4.1-4.4-1.4-5.5-3.1-1.4-4.1-1.3-3.4-2.1 2.1-1.3-3.8-6.2-3.1-1 1.7-3.1.4-1.7 2.7.7 3.8-3.1 3.1-11.3 4.4-5.8-4.4h-5.5l-7.5 1.3-2.1 5.8-1.4 7.9 1.8 4.1h2.4l1.7 2.4 7.2 7.2-.4.1 7.8 3.5 6.6 1 9.3 1.1 5.7 1.8 8 6 3 .2 5.2.7 4.6 3.6 7.5 7.5 5.3 3.2 2.3-.4.4-.9.9-3.2 3.7-1.4 4.8 1.8 5.2 3.2 1.7 1.2-2.4-3.7 5.7-.2 2.8-2.7 3.9.4.9 1.8 3.4.9-.2 1.2 2.7 2.5 5.9 3.4 4.6 3.9 4.8 2.3 4.8 1.1 3.2 3.7 4.8 3.3-2.3-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M681.8 556l-2.1-2.7-3.9 1.8 1.4 3.4 2.5-.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N60",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M665.6 554.6l-4.8-1.8-3.7 1.4-.9 3.2-.4.9-2.3.4-5.3-3.2-7.5-7.5-4.6-3.6-5.2-.7-3-.2-8-6-5.7-1.8-9.3-1.1-6.6-1-7.8-3.5-5.8 1.9-4.1.4-1.4 3.8-4.1 1.5.7 2.2-.3 2.8-3.1 4.7-1.7 2.4.6 2.4.4 2.4-1.4 4.5-2.7 1-3.4.7-1.8-2.4-2 3.8-1.4 1.7-1.8 1.4 1.8 1.4 7.6.5.6 3.6 3.2-.2 3.9-3.4 6.4 1.4 6.8-1.2 6.9-1.6.9 2.1 6.6.2 3.7-5.5h5.2l5.7 5.5.9 3.4 4.6 2.5 7.1 3.2 2.9 1.6 2.3 3.2 5 1.6.5 1.8 3.4 2.8-1.4 2.7 6.4 3.9 5 3 4.8.9 4.1.2 3.9-2.1 3-1.3 3.2 2.3 3.4 1.3.9-1.3-.7-3.2-3.8-3.5 1.3-2-6.8-5.5 7.7 3.2 4.1-1.8 3-2.8-.4-2 .4-4.1-4.3-2.1.2-8.2-4.6-6.6-.1-.2-1.7-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M690.7 579.3l-3.2 1.1-2.5.9-3.7 3.2-4.6 4.4 1 2.9 3.2 1.8 4.3 2.6 6.1-1 8.3 3.2 10.9.3 9.6-.7h4.8l-1.8-3.4-4.3-1.5-1-.4-6.8-1.3-6.7-3-.4-1.8-1.6-3.4-4.3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N1",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621.3 78.3l-.9-3.9-8.4-.9-4.1 4.1 3.1 5.7 7.1 4.3.5-3.8 5-.3 3.2-1.6zM566.3 33.1l-2.7-8-3.7.7-2 2.8.2 2.5-1.8 2.5-6.9 2.5-3.8 1.6-.5-1.8-3.9 1.8-3.2 2.5-2 5.9 2 3.9 7.3-.5 4.6-.9 2.5-2.9 1.8-1.4 1.4.7 2.1-1.4-3-4.6 2-4.3 2.6.5.2 2.5 2.5 2.5 4.8.4-.7-2.9zM611.7 26.3l-4.8-.3-2.9-1.8h-7.3l-3 .5-2 1.3-1.9 1-5 6.3-6.4.3-4.3 6.4-.5 5.2-1.6 8.2 2.5 3.7v4.1l-1.1 5.2 3 4.6 2-2.7 1.2-2.3 4.1-1.9 3.6-3.1 5.9-3 4.8-.9 5.1-1.6 2-3.9 1.8 3.6 2.8-3.1 2.9-3.7-1.6-3.6v-6l4.2-6.4zM627.5 35.9l-3 2 2.3 3.7 3-1.2.2-3.6-1.9-.7zM617.9 45.4l-3.7 1.6-.9 4.6 2.1.5h1.1l1.4-2.8zM647.3 107.7l-2.7.2 1.6 2.3h2zM614 121l-3.9 2.2-.4 3.5 2.9-1.2 2.6-2.5zM612.2 117.8l-4.1 3.2v.6l1.6.7 4.1-2.5zM614.7 126.7l-5.3 3.1 2.8 1 2.7-1.9zM623.8 99l-2 1.4-.5 2.5 3 .3.7-1.9zM540.8 51.1l-3 .7-2 1.4 1.1.9 3.4-.7 2.3-.4zM572.5 72.8h-3.7l1.6 1.8 3.2.3zM620.4 26.5l-1.8 1.6 1.8 2.1 1.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.1 154l.5-3.8-3-3.9 1.4-3.7 1.6-4.8-5.1-4.3-1.3-1.8-2.1-4.4-.2-4.1-2.3-1.1 2.1-3 3.2-4.3.4-11.6-.4-4.6-9.6-1.6-5.3-7.3-6.2-.6 1 2.2-2.5 3-.3 2.7 2.1 3.9-1.2 17.5-4.5 5.5.2 9.6 5.3 19.6 1.3 3 1.6 11.6v-.1l6.2-.3 4.1 1.3 3.1-2 2.4-2.8 4.4.7 1.4-1.3 3.2-5.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N2",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M513.3 107.4l6.2 1.6 3.2 1.4.5 3 5.3 7.8 3 6.4 4.6 1.1 2.1.4 1-2.7.5-4.3-.7-3.9-.2-2.3-3.9-.5-5.7-.7-1.8 1.4-.2-3.9 2.3-.7 2.7-1.6s.5 2.1 3.7.9l3.2-1.1-4.8-8.4-2.5-2.3-1.1-5.7-4.6-5.2-5.9-3.2-5.9 4.8-2.7 5.2-1.6 8-1.6 6.2 1-.1 3.9-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N22",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.3 329.5l.2-7.6-.9-3.6-5.5-.2-3.4 2.9-2 .5-2.8-1.2-2 .5-1.6-.7-.5-2.3 2.8-2-.3-1.4-4.3-3.9-13.8 6.4 3.3 4.1-.7 7.1-1.1 8-1.7 4.3 6.6-1.4 4.4-2.3 9.6-5.2 8.2 1 .3 1.4 3.4-2.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N21",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.2 317.8l-7.2-1.3-4.8-2.4-3.7-2.8-4.5-4.8h-3.4l-2.1-2.7-3.7-1-1.2-.7.1.3-4.7-1.3-7.3-3.2-.2.5-11.1 11.2-16.5 5.7 1.3 1.6 13.8-6.4 4.3 3.9.3 1.4-2.8 2 .5 2.3 1.6.7 2-.5 2.8 1.2 2-.5 3.4-2.9 5.5.2.9 3.6-.2 7.6-1.8 1.6-3.4 2.8 1.1 4.8 1 5.8 2.1 3.8 3.1-2.1 3-3 1.7-3.8 4.8-1.4 5.2-2.4 2-3.4.4-3.4-.4-3.8 1.7-1.4 1.7 3.5 3.1.7 2.4-1.8 5.1-3.4 3.1-4.4.3-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N20",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.8 299.7l-4.1-3.8-4.4-.3-3.1-5.1-3.1-3.1-1-6.2-1.3-3.1-3.2 2.4-8.2 1.7-4.4.7-5.2 2.4-1.2-.1 3.1 6.4-8.4 4.3 3.3 6.2 1.2.7 3.7 1 2.1 2.7h3.4l4.5 4.8 3.7 2.8 4.8 2.4 7.2 1.3 3.1-2.7 4.8-1.4 1.3-2.4 1.1-3.7 1.3-6.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N11",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M476.6 270.9l1.2-3.5-1.6-1.6-3.8 1-4.1-2.7-.6-2.7-4.8-8.9 3-3.5-2.7-5.4-.3-4.1-.1-1-12.4-1.4-9.5 3.8.2 5.1-.5 4.1-3.9-.7-3.4-6.4h-5.7l-5.7 9.9 3 2.7-.4 1.7.4 3.4 5.1 1.4 3.1-.7h5.1l.7 1.7-2 2.7.6 6.5-5.1 2.1-2 2.7 1.7 4.1 1 6.2 3.1 3.1 3.1 5.1 4.4.3 4.1 3.8 1.4 1.4 4.1 1 4.1-3.8 2.4-9.9 1-2.7 4.8-.7 2.4-2.1 4.1-4.1 2.4-2.4 3.8-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N32",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M493 315.1l-2.4-.3-1.7-.7 1-4.5-5.5-2.7 1.1-5.2-.4-3-.7-3.1 2.4-3.1-1-2-7.2-2.1-2.7-3.8-5.5-2h-2.1l-.3.3-2.4 2.1-4.8.7-1 2.7-2.4 9.9-4.1 3.8-4.1-1-.4-.4-1.3 6.9-1.1 3.7-1.3 2.4-4.8 1.4-1.8 1.5-.3 1.6-3.1 4.4-5.1 3.4-2.4 1.8-3.1-.7-1.7-3.5-1.7 1.4.4 3.8-.4 3.4-2 3.3 2.4 3.8 1.3 3.6 3.2 1.2 2.8 3.2 2.5.4 2.9 3.4.7 3.7 3.2.4 2.5 3.5 6.2 3.6 4.3.7 3.7 2.1-.1-2.1 6.5-6.5 10.9-3.8 9.6-2.4 4.4-3.4.3.9.8-1.6.6-2.4-.3-3.4 1-3.1 1.1-1.7.6-1.3 1.1-7.2 2-2.4.7-4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N30",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.5 293.6l1.8-2.9 3.4-1.6 4.3-5 2.1-2.8.7-1.3.7-2.3-1.6-2.5-1.4.4-1.8 4.1-3.4 1.2-5.3-2.5-1.1-2.8-4.6-.7-3-1.1-1.1.9-2.7 1.4-4.2-.9-2.8 1.2-2.4 2.4-3.8 3.8h2.1l5.5 2 2.7 3.8 7.2 2.1 1 2-2.4 3.1.4 1.6 4.9-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N31",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M537.8 279.7l-.9-.2 1.1-2.7-.6-1.2-.3-1.3 1.4-1.9v-.9l-.9-1.1-.5-.9h-13.2l.2-1.9 1.2-1.8 2.2-3v-2.5l-1.1-1.8-2.5-.4-3.7 2.9-3.1 1.8-6-2.7-1.8 1.2-2.5 12.7-.9 1.2 1.6 2.5-.7 2.3-.7 1.3-2.1 2.8-4.3 5-3.4 1.6-1.8 2.9-4.8 2.3-4.9 1.3.3 1.5.4 3-1.1 5.2 5.5 2.7-1 4.5 1.7.7 2.4.3 1 5.5-.7 4.1-2 2.4-1.1 7.2-.6 1.3-1.1 1.7-1 3.1.3 3.4-.6 2.4-.8 1.6.4 1.9 3.1-.7 4.8.7 5.5-2.1.7 3.1 2 .7 6.9 3-.2.3 3.6-.3 7.2 2.8 6.5 2.7 6.8.4 2.7-.4-.3-2 1-4.1 4.5-2.1 1.3-7.2 3.5-5.8 1.7-3.8 1.7-7.8 4.8-.7 5.1-2.1h4.5l2.7-3.7 2.1-.7v-1.7l-4.8-4.5-2.8-8.5-4.4-3.1-4.5-2.1-2.7-1.7-2.1-2-4.1-.7-1.3.3-3.8-3.1 1.4-3.7 1.3-2.8-1.7-2.3.2-.8-1-.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N29",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.3 214.1l-.2-1.8-.2.1-3.7-.7-2.1 3.1-7.9 3.4-2.4 4.5-3 1.7-6.2 3.1v1.7l-5.8-1-6.2-1.4-2 2.1-5.8.3-1.8 1.7-3.7 2.1-.5-.8-2.3 3.8-5.4 3.1-3.1 7.2-2.1 6.9-2.7 5.4-5.5 7.9-1 1.4h-3.4l-.5-.5-1.2 3.5 1.7 3.8-1 .5 4.2.9 2.7-1.4 1.1-.9 3 1.1 4.6.7 1.1 2.8 5.3 2.5 3.4-1.2 1.8-4.1 1.4-.4.9-1.2 2.5-12.7 1.8-1.2 6 2.7 3.1-1.8 3.7-2.9 2.5.4 1.1 1.8v2.5l-2.2 3-1.2 1.8-.2 1.9h13.2l.5.9.9 1.1v.9l-1.4 1.9.3 1.3.6 1.2-1.1 2.7.9.2.9 3 1 .5.8-2.7 28.1-19.1 25.3-3.5V233z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N5",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M581.6 200.1l-3.4-4.8 1-2.4-2.7-4.8-4.8-2-.7-1.7-2.7-.4-2.8 1.1-3.1-3.1-3-1.7 2.4-2.1-2.8-.7-4.8-4.1-2.7-8.2-3.8-1-8.7-2.7-1.6 3-2.8 1.2-6.1 2-2.8-.9-4-4.9-1.5 3.8-.2 5.4-6.6 4.6v3.9l4.1 1.3.2 5.3-2.2 1.1-10.3 7.1-3.4-3h-6.7l-3.9 1.1-1 4.2 3.5 1-.4 2.8v6.1l5.2 1.4 2.7 2.7-2.7 8.2-3.5 3.1 1.1 4.5 5.8 2.7 2.4 3.8 3.7-2.1 1.8-1.7 5.8-.3 2-2.1 6.2 1.4 5.8 1v-1.7l6.2-3.1 3-1.7 2.4-4.5 7.9-3.4 2.1-3.1 3.7.7 4.8-3.7 1 .7 3.5-2.1h4.8l3.7 2.4 6.5.3 2.4-1.3-2-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N49",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M964.6 402.2l-2-1.4-2-3.4 2.2-6.1 1.1-3.9-3.6-10.1-8-9.5-10.4-3.4-1.4-2.5h-6.6l-.3 3.6 1.4 2.8-2.7 4.7h-10.1l-10.4-5-6.8-.9 1.1 9.9-4.8 4.1v6.2l-6.5 8.2-92.7-1.7-5.5 6.5-1 1.4-9.9 5.8-4.4-.3-25.7 4.4 7.2 5.9 8.9 3.1 3.4 2.4 2.7 4.1 2.7 1.7 6.2-.3 5.1 1.7.7 3.8 2.4 6.5 5.8 1.4 5.8.3 2.4-.3h1.4l.8 1.6.6-.4 3.3 2.2 3.1.6 2.9 2 .4 3.1.2 2.5.4 2.5 3.3 3.5 4.3 1.4 5.1-.6 4.1-5.9 5.1 1.4 3.3-.2 4.1.8s.8-.2 5.1 0l4.3.2 3.7-1.2 3.5-1.4 5.7.8 4.3-2.5 6.7-2.7 8.2-2.9 10-6.5 13.9-4.3 11-1.6 18.6-7.8 10-8.6 3.7-4.1.4-2.7 2.5-1.2 2.2-5.3-.5-2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "matrix(1, 0, 0, 1, -21, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(607.5 64.15)"
  }, "\n      N1\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(515.62 105.77)"
  }, "\n      N2\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(564.78 133.6)"
  }, "\n      N3\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(508.76 131.57)"
  }, "\n      N4\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(521.44 200.52)"
  }, "\n      N5\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(462.45 163.94)"
  }, "\n      N6\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(475.05 232.46)"
  }, "\n      N7\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(435.97 194.41)"
  }, "\n      N8\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(441.08 231.7)"
  }, "\n      N9\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(415.22 232.2)"
  }, "\n      N10\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(444.12 272.26)"
  }, "\n      N11\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(383.77 251.3)"
  }, "\n      N12\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(413.44 273.62)"
  }, "\n      N13\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(358.91 266.4)"
  }, "\n      N14\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(332.3 294.9)"
  }, "\n      N17\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(424.94 313.64)"
  }, "\n      N20\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(344.83 278.16)"
  }, "\n      N15\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(404.55 322.19)"
  }, "\n      N21\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(311.6 285.21)"
  }, "\n      N16\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(355.72 306.5)"
  }, "\n      N18\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(398.39 294.24)"
  }, "\n      N19\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(364.58 331.23)"
  }, "\n      N22\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(376.38 349.25)"
  }, "\n      N23\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(342.7 366.04)"
  }, "\n      N24\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(350.7 387.21)"
  }, "\n      N25\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(277.44 378.6)"
  }, "\n      N26\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(327.32 415.52)"
  }, "\n      N27\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(327.63 507.65)"
  }, "\n      N28\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(545.25 239.08)"
  }, "\n      N29\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(476.81 285.21)"
  }, "\n      N30\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(510.52 314.87)"
  }, "\n      N31\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(456.53 321.72)"
  }, "\n      N32\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(422.57 371.4)"
  }, "\n      N33\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(391.64 384.33)"
  }, "\n      N34\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(369.52 413.32)"
  }, "\n      N35\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(375.42 485.46)"
  }, "\n      N36\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(425.86 424.13)"
  }, "\n      N37\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(444.87 508.79)"
  }, "\n      N38\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(621.3 204.99)"
  }, "\n      N39\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(608.37 306.5)"
  }, "\n      N40\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(692.53 300.68)"
  }, "\n      N41\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(733.34 288.4)"
  }, "\n      N42\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(730.81 333.43)"
  }, "\n      N43\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(743.33 311.2)"
  }, "\n      N44\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(758.23 280.19)"
  }, "\n      N45\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(767.74 290.64)"
  }, "\n      N46\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(599.63 413.35)"
  }, "\n      N47\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(797.34 362.02)"
  }, "\n      N48\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(880.6 422.86)"
  }, "\n      N49\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(731.18 446.05)"
  }, "\n      N50\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(747.15 495.1)"
  }, "\n      N51\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(850.2 516.01)"
  }, "\n      N52\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(829.4 565.44)"
  }, "\n      N53\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(798.23 535.53)"
  }, "\n      N54\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(747.02 533.25)"
  }, "\n      N55\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(768.57 561.89)"
  }, "\n      N56\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(720.2 592)"
  }, "\n      N57\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(698.74 529.82)"
  }, "\n      N58\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(642.08 518.42)"
  }, "\n      N59\n    "), /*#__PURE__*/React.createElement("text", {
    transform: "translate(638.79 570.14)"
  }, "\n      N60\n    ")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDSabah);
export default __webpack_public_path__ + "static/media/d_sabah.93ea2926.svg";
export { ForwardRef as ReactComponent };